"use client";

import React from "react";
import { motion } from "framer-motion";

interface VelvetRopeGateProps {
    onPass: () => void;
}

export default function VelvetRopeGate({ onPass }: VelvetRopeGateProps) {
    const sliderConstraintsRef = React.useRef<HTMLDivElement>(null);
    const [isDragging, setIsDragging] = React.useState(false);

    // Threshold to trigger unlock (percentage of width approx or px value)
    const handleDragEnd = (event: any, info: any) => {
        setIsDragging(false);
        // If dragged more than 200px (adjust based on UI width), unlock
        // The container is relative w-full but max-w-md (approx 450px)
        // 200px is a reasonable threshold for intent
        if (info.offset.x > 150) {
            onPass();
        }
    };

    return (
        <div className="relative w-full max-w-md mx-auto p-8 rounded-2xl bg-[#E6E4E0]/90 backdrop-blur-md border border-neutral-300 shadow-xl overflow-hidden text-center space-y-6">
            {/* Visual Accent */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-12 bg-gradient-to-b from-transparent to-[#2C2C2C]/20" />

            <div className="space-y-2 pt-8">
                <h2 className="font-display text-2xl text-[#2C2C2C] italic">
                    Private Access Only
                </h2>
                <div className="space-y-4 font-sans text-sm text-neutral-600 leading-relaxed">
                    <p>
                        This contact channel is reserved for<br />
                        personal connection.
                    </p>
                </div>
            </div>

            {/* Slider Container */}
            <div
                className="relative w-full h-14 rounded-full bg-[#2C2C2C]/5 border border-neutral-300 flex items-center justify-center overflow-hidden"
                ref={sliderConstraintsRef}
            >
                {/* Track Text */}
                <span className={`absolute pointer-events-none text-[10px] uppercase tracking-[0.2em] text-[#2C2C2C] transition-opacity duration-300 ${isDragging ? "opacity-0" : "opacity-100"}`}>
                    Slide to enter
                </span>

                {/* Draggable Thumb */}
                <motion.div
                    drag="x"
                    dragConstraints={sliderConstraintsRef}
                    dragElastic={0.05}
                    dragMomentum={false}
                    onDragStart={() => setIsDragging(true)}
                    onDragEnd={handleDragEnd}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="absolute left-1 h-11 w-11 rounded-full bg-[#D4AF37] shadow-md z-10 cursor-grab active:cursor-grabbing flex items-center justify-center border border-white/10"
                >
                    {/* Thumb Icon/Arrow */}
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="text-[#EAE8E4] ml-0.5">
                        <path d="M9 18l6-6-6-6" />
                    </svg>
                </motion.div>
            </div>
        </div>
    );
}
